import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config";
import FullWithBulletsParagraphConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config";
import { newBrandColors } from "constants/color-picker-constants";
import TitleConfig from "segments/desktop/core-components/title/fields-config";

const {
  topic,
  buttonConfig,
  body,
  theme,
  mobileTextAlign,
  bodyColor,
  titleColor,
  bulletsConfig,
  ...restOfFullWithBulletsParagraphConfigFields
} = FullWithBulletsParagraphConfig.fields;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Products By Use Cases",
  fields: {
    horizontalPadding: {
      type: FIELD_TYPES.TEXT,
      label: "Products horizontal padding"
    },
    tagsTitle: { type: FIELD_TYPES.TEXT, label: "Tags title", textArea: true, translatable: true },
    sideBarTitle: { type: FIELD_TYPES.TEXT, label: "Use cases side bar title", textArea: true, translatable: true },
    useCases: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Use cases",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          tag: {
            type: FIELD_TYPES.NESTED,
            fields: {
              text: { type: FIELD_TYPES.TEXT, label: "Tag text", translatable: true },
              color: {
                type: FIELD_TYPES.COLOR_PICKER,
                label: "Tag Color",
                possibleColors: [...newBrandColors, "orange"]
              }
            }
          },
          product: {
            label: "Product",
            type: FIELD_TYPES.NESTED,
            fields: {
              ...restOfFullWithBulletsParagraphConfigFields,
              productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
              bulletsConfig: {
                type: FIELD_TYPES.NESTED,
                label: "Product use cases",
                fields: {
                  bullets: bulletsConfig.fields.bullets
                }
              },
              asset: {
                type: FIELD_TYPES.NESTED,
                label: "Asset",
                fields: AssetFieldsConfig
              }
            }
          }
        }
      }
    }
  }
};
